import { useEffect, useState } from "react";

const KEY = "vl-site";
export const SITE_EVT = "vl-site-change";
export const SITES = ["applicant", "business"];
export const getSite = () => { const v = typeof window !== "undefined" ? localStorage.getItem(KEY) : null; return SITES.includes(v) ? v : null; };
export const setSite = (id) => { if (!SITES.includes(id)) return; localStorage.setItem(KEY, id); window.dispatchEvent(new Event(SITE_EVT)); };
export function useSite() {
  const [s, setS] = useState(getSite);
  useEffect(() => { const h = () => setS(getSite()); window.addEventListener(SITE_EVT, h); return () => window.removeEventListener(SITE_EVT, h); }, []);
  return s;
}
